import en from './en';
import fr from './fr';

export default {
  french: {
    id: 'fr',
    flag: require('../assets/flag/fr.png'),
    dictionary: fr,
  },
  english: {
    id: 'en',
    flag: require('../assets/flag/en.png'),
    dictionary: en,
  },
};
